import "../../common/toggle-group.js";
import { apiHost, FRIENDLY_ERROR_MESSAGE } from "../../lib/utils.js";
import axios from "axios";
import { css, html } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import "./pet-insurance-plan.js";
import { PackageToggleOfferElement } from "../../lib/package-toggle-offer-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { when } from "lit/directives/when.js";
import { OfferRadioButtonType } from "../../common/offer-radio-button.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
function compare(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}
let PetInsurance = class extends PackageToggleOfferElement {
  constructor() {
    super();
    this.annualLimit = 1e4;
    this.deductibleAmount = 500;
    this.breedSchema = void 0;
    this.breedNotFound = false;
    this.product = "pet-insurance";
  }
  async connectedCallback() {
    const response = await axios.get(`${apiHost}/v1/products/pet-insurance/breeds`, {
      headers: {
        "Content-Type": "application/json",
        "x-api-client-id": this.clientId,
        "x-api-source": "Web Component",
        "x-api-web-component-version": "4.7.1"
      }
    });
    const breedData = {
      DOG: response.data.DOG.sort(compare),
      CAT: response.data.CAT.sort(compare)
    };
    this.breedSchema = breedData;
    this.getDeclaredBreedId();
    super.connectedCallback();
  }
  getDeclaredBreedId() {
    var _a, _b, _c, _d;
    const foundBreedId = (_b = (_a = this.getBreedOptions()) == null ? void 0 : _a.find((b) => b.name == this.declaredBreed)) == null ? void 0 : _b.id;
    if (foundBreedId) {
      this.breedNotFound = false;
      this.breedId = foundBreedId;
    } else {
      this.breedNotFound = true;
      this.breedId = (_d = (_c = this.getBreedOptions()) == null ? void 0 : _c.find((b) => b.name == this.getMiscellaneousBreedName())) == null ? void 0 : _d.id;
    }
  }
  getBreedOptions() {
    var _a, _b;
    if (this.species == "CAT") {
      return (_a = this.breedSchema) == null ? void 0 : _a.CAT;
    }
    return (_b = this.breedSchema) == null ? void 0 : _b.DOG;
  }
  getMiscellaneousBreedName() {
    if (this.species === "CAT") {
      return "Mixed Breed - Cat";
    }
    return "Rare Breed";
  }
  updateBreedSelection(e) {
    const target = e.target;
    this.breedId = target.value;
  }
  displayBreedSelection() {
    var _a;
    if (this.breedNotFound) {
      return html`
        <section id="breed-selection">
          <p>We couldn't quite find a match for the breed <strong>${this.declaredBreed}</strong>. Please select the proper breed in the dropdown list, or select <strong>${this.getMiscellaneousBreedName()}</strong></p>
          <select @change=${this.updateBreedSelection} .value=${this.breedId}>
            ${(_a = this.getBreedOptions()) == null ? void 0 : _a.map((i) => html`
              <option value=${i.id} ?selected=${this.breedId === i.id}>${i.name}</option>
            `)}
          </select>
        </section>
      `;
    }
  }
  render() {
    var _a;
    return (_a = this.productController) == null ? void 0 : _a.render({ complete: () => html`
      <div id="offer-display">
        <div id="offer-tag">Recommended</div>
        <div id="multi-offer-wrapper">
          ${this.displayBreedSelection()}
          <div id="pre-existing-condition-question">
            <fieldset>
              <legend> Has your pet ever shown symptoms, received treatment for, or been diagnosed with the following conditions?</legend>
              <div class="fieldset-description">Addison’s Disease, Cushing’s Disease, Diabetes, Cancer, Feline Leukemia or Feline Immunodeficiency Virus</div>
              <div>
                <label>
                  <input type="radio" name="pre_existing_conditions" value="true" @change=${() => {
      this.preExistingConditions = true;
    }}>
                  <span>Yes</span>
                </label>
                <label>
                  <input type="radio" name="pre_existing_conditions" value="false" @change=${() => {
      this.preExistingConditions = false;
    }}>
                  <span>No</span>
                </label>
              </div>
            </fieldset>
          </div>
          
          <div id="offers">
            ${["INJURY_ONLY", "INJURY_AND_ILLNESS"].map((plan, i) => html`
              <pet-insurance-plan 
                data-unique-id=${i}
                .clientId=${this.clientId} 
                .customerFirstName=${this.customerFirstName} 
                .customerLastName=${this.customerLastName}
                .customerEmailAddress=${this.customerEmailAddress}
                .customerCity=${this.customerCity}
                .customerStreetAddress=${this.customerStreetAddress}
                .customerPostalCode=${this.customerPostalCode}
                .customerState=${this.customerState}
                .age=${this.age}
                .plan=${plan}
                .annualLimit=${this.annualLimit}
                .breedId=${this.breedId}
                .gender=${this.gender}
                .petName=${this.petName}
                .species=${this.species}
                .deductibleAmount=${this.deductibleAmount}
                @offer-state-change=${this.offerStateChangeHandler}
                .disabled=${plan === "INJURY_AND_ILLNESS" ? this.preExistingConditions === void 0 || this.preExistingConditions === true : this.preExistingConditions === void 0}
              ></pet-insurance-plan>
            `)}
          </div>
          <div class="decline-action">
            <offer-accordion-header .type=${OfferRadioButtonType.DECLINED} .showIcon=${false} .showPromotionalHeader=${false} @change=${this.decline} .checked=${this.selectedState === SelectedState.DECLINED}>
              <h1>No, do not protect my pet.</h1>
            </offer-accordion-header>
          </div>
          ${when(this.errors.length > 0 && this.errors.some((v) => v in FRIENDLY_ERROR_MESSAGE), () => html`
            <section id="errors" class="error-message">
              ${this.errors.map((e) => html`<p>${FRIENDLY_ERROR_MESSAGE[e]}</p>`)}
            </section>
          `)}
          ${this.renderPaymentElement()}
          <section id="legal-disclaimer">
            <legal-disclaimer></legal-disclaimer>
          </section>
        </div>
      </div>
    ` });
  }
};
PetInsurance.styles = [
  PackageToggleOfferElement.styles,
  css`
      :host {
        margin-top: 10px; 
      }

      section#breed-selection {
        margin:0;
        margin-top: var(--default-vi-package-display-spacing);
        margin-bottom: var(--default-vi-package-display-spacing);
        --lumo-space-xs: 0;
      }

      section#breed-selection p {
        margin-top: 0;
        margin-bottom: 5px;
      }


      #plan-type {
        border: 1px solid var(--default-vi-border-color);
        border-radius: var(--default-vi-border-radius);
        padding: 6px 10px;
        display: flex;
        align-items: center;
      }

      #plan-type label {
        display: block;
        margin-right: 0.55rem;
        font-size: 0.85rem;
        white-space: nowrap;
      }

      #plan-type-menu {
        position: relative;
        width: 100%;
      }

      #plan-type-menu svg {
        position: absolute; 
        right: 0.5rem;
        top: 0.5rem;
      }

      select {
        box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
        border: 1px solid var(--default-vi-border-color);
        background-color: #ffffff;
        border-radius: var(--default-vi-border-radius);
        cursor: pointer;
        appearance: none;
        width: 100%;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
        background-position: right 1rem center;
        background-repeat: no-repeat;
        background-size: 1.5em 1.5em;
        padding: 1rem 2.5rem 1rem 1rem;
      }

      select:focus-visible {
        outline: none;
      }

      #pre-existing-condition-question {
        padding: 12px;
        border: 1px solid var(--default-vi-border-color);
        border-radius: var(--default-vi-border-radius);
        margin-bottom: var(--default-vi-package-display-spacing);
      }

      .fieldset-description {
        opacity: .75;
        margin: 1rem 0 1rem 1.5rem;
      }

      @container (max-width: 700px) {
        #plan-type { 
          align-items: flex-start;
          padding: 0;
          border: none;
          margin: 0 0 10px 0;
        }

        #plan-type label {
          margin-right: 0;
          margin-bottom: 0.45rem;
        }
      }

      @media (max-width: 700px) {
        #plan-type { 
          align-items: flex-start;
          padding: 0;
          border: none;
          margin: 0 0 10px 0;
        }

        #plan-type label {
          margin-right: 0;
          margin-bottom: 0.45rem;
        }
      }
    `
];
__decorateClass([
  property({ attribute: "species" })
], PetInsurance.prototype, "species", 2);
__decorateClass([
  property({ attribute: "declared-breed" })
], PetInsurance.prototype, "declaredBreed", 2);
__decorateClass([
  property({ attribute: "pet-name" })
], PetInsurance.prototype, "petName", 2);
__decorateClass([
  property({ type: Number, attribute: "age" })
], PetInsurance.prototype, "age", 2);
__decorateClass([
  property({ attribute: "gender" })
], PetInsurance.prototype, "gender", 2);
__decorateClass([
  property({ type: Number, attribute: "annual-limit" })
], PetInsurance.prototype, "annualLimit", 2);
__decorateClass([
  property({ type: Number, attribute: "deductible-amount" })
], PetInsurance.prototype, "deductibleAmount", 2);
__decorateClass([
  state()
], PetInsurance.prototype, "breedSchema", 2);
__decorateClass([
  state()
], PetInsurance.prototype, "breedId", 2);
__decorateClass([
  state()
], PetInsurance.prototype, "breedNotFound", 2);
__decorateClass([
  state()
], PetInsurance.prototype, "preExistingConditions", 2);
PetInsurance = __decorateClass([
  customElement("pet-insurance")
], PetInsurance);
export {
  PetInsurance
};
